<script>
export default {
  name: "Size",

  computed: {
    size: (vm) => vm.$store.getters.GET_SIZE,
  },
};
</script>
